import Router from 'next/router'

import excludeBlankKeys from '@/helpers/excludeBlankKeys'

import { ChangePageEvent } from '../ts'

function changePage(
  event: ChangePageEvent,
  scrollViewOffsetTop?: number,
  replace?: boolean
) {
  const page = event.selected + 1
  const query = excludeBlankKeys<string>({ ...Router.query, page })
  if (replace) Router.replace({ query }, undefined, { shallow: true })
  else Router.push({ query }, undefined, { shallow: true })

  scrollViewOffsetTop !== undefined &&
    window.scrollTo({ top: scrollViewOffsetTop - 80 })
}

export default changePage
